/**
 * Frontend Audit Types
 */

export enum AuditCategory {
  Authentication = 'Authentication',
  Authorization = 'Authorization',
  DataAccess = 'DataAccess',
  Configuration = 'Configuration',
  UserAction = 'UserAction',
  SystemEvent = 'SystemEvent',
  Security = 'Security',
  TeamsOperation = 'TeamsOperation',
  Integration = 'Integration'
}

export enum AuditLevel {
  Verbose = 'Verbose',
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
  Critical = 'Critical'
}

export interface AuditEvent {
  id: string;
  timestamp: Date | string;
  correlationId: string;
  userId: string;
  userEmail?: string;
  userRoles?: string[];
  sessionId?: string;
  action: string;
  category: AuditCategory;
  level: AuditLevel;
  source: string;
  ipAddress?: string;
  userAgent?: string;
  browserType?: string;
  operatingSystem?: string;
  resource?: string;
  resourceId?: string;
  result?: 'Success' | 'Failure' | 'PartialSuccess';
  errorDetails?: any;
  duration?: number;
  metadata?: Record<string, any>;
  method?: string;
  path?: string;
  statusCode?: number;
  summary?: string;
  details?: string | Record<string, any>;
}

export interface AuditSearchCriteria {
  startDate?: Date;
  endDate?: Date;
  userId?: string;
  action?: string;
  category?: AuditCategory;
  level?: AuditLevel;
  result?: 'Success' | 'Failure';
  resourceId?: string;
  searchText?: string;
  pageSize?: number;
  continuationToken?: string;
}

export interface AuditSearchResult {
  events: AuditEvent[];
  totalCount: number;
  continuationToken?: string;
}

export interface AuditStats {
  totalEvents: number;
  eventsByCategory: Record<string, number>;
  eventsByLevel: Record<string, number>;
  topUsers: Array<{ userId: string; count: number }>;
  recentEvents: AuditEvent[];
}